import { type CrmObject, ObjectTypes } from '@playbooks/action-cards-utils/src'
import FieldWithIcon from './FieldWithIcon'
import { type FC } from 'react'
import IconWrapper from './IconWrapper'
import { PlusCircleGradientIcon } from '../../../components/ui'
import { useTranslation } from '../../../contexts/localization/Localization'
import getCrmObjectName from '../../../utils/getCrmObjectName'
import { getContactFullName } from '../../../utils/mapConnecterWidgetValue'

const CreateListItem: FC<{ crmObject: CrmObject }> = ({ crmObject }) => {
  const { text } = useTranslation()
  const type = getCrmObjectName(crmObject.objectType)
  const name =
    crmObject.objectType === ObjectTypes.Contact ? getContactFullName(crmObject.crmFields) : crmObject.crmFields.Name

  return (
    <FieldWithIcon
      icon={<IconWrapper icon={<PlusCircleGradientIcon />} />}
      data={
        <div className={`dark:text-white`}>
          <div>
            <span className={`font-bold`}>
              {text('create')} {type}: <span className={`font-normal`}>{name}</span>
            </span>
          </div>
          <div>
            <i className={`mr-1`}>{text('connectCrmWidgetNotFound').replace('{type}', type)}</i>
          </div>
        </div>
      }
    />
  )
}

export default CreateListItem
